type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function Input(props: InputProps) {
  return (
    <input
      {...props}
      className={`w-full rounded-xl border-[1.5px] border-line bg-[#FBFAF6] px-3.5 py-3 text-[14.5px] text-ink outline-none placeholder:text-placeholder focus:border-accent focus:bg-white ${props.className ?? ""}`}
    />
  );
}
